import React from "react";

import { Drawer } from "../../components/Drawer";
import { Empty } from "../../components/Empty";
import { NodeForms } from "./CdpNodeForms";

export class NodeDrawer extends React.Component {
  state = {
    selectedNode: null,
  };

  componentDidMount() {
    const { clause } = this.props;

    this.setState({
      selectedNode: clause,
    });
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.visible && this.props.visible) {
      this.setState({
        selectedNode: this.props.clause,
      });
    }
  }

  renderForm() {
    const { selectedNode } = this.state;
    const { visible, onClose, onSave, onRemove, flowType, restrictions } =
      this.props;

    if (NodeForms[selectedNode.type]) {
      const FormComponent = NodeForms[selectedNode.type];

      return (
        <FormComponent
          key={`node-${selectedNode.id}`}
          node={selectedNode}
          flowType={flowType}
          restrictions={restrictions}
          visible={visible}
          onClose={onClose}
          onChange={(node) => this.setState({ selectedNode: node })}
          onRemove={(node) => onRemove && onRemove(node)}
          onSave={(node, close) => onSave && onSave(node, close)}
        />
      );
    }

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        direction="center-right"
        parentSelector={() => document.getElementById("oracle-flow")}
      >
        <Empty>
          <i className="far fa-arrows-split-up-and-left"></i>
          <p>Não há configurações.</p>
          <span>Não existem configurações para essa box</span>
        </Empty>
      </Drawer>
    );
  }

  render() {
    const { selectedNode } = this.state;

    return selectedNode && this.renderForm();
  }
}
